<template>
  <RevContainer>
    <RevInfoBlock
      v-if="killMySalesAccess"
      class="mx-auto max-w-4xl"
      :content="i18n(translations.mySalesNotAvailableContent)"
      :icon="IconCrossInCircle"
      :title="i18n(translations.mySalesNotAvailableTitle)"
      variant="danger"
    />
    <SalesList v-else></SalesList>
  </RevContainer>
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevContainer } from '@ds/components/Container'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconCrossInCircle } from '@ds/icons/IconCrossInCircle'

import SalesList from '~/scopes/dashboard/my-sales/components/SalesList/SalesList.vue'

import translations from './MySales.translations'

const runtimeConfig = useRuntimeConfig()
const i18n = useI18n()

const { KILL_MY_SALES_ACCESS_BY_COUNTRY } = runtimeConfig.public
const killMySalesAccess = KILL_MY_SALES_ACCESS_BY_COUNTRY.includes(
  useMarketplace()?.market.countryCode,
)
</script>
